import React, { Component } from "react";
import ModalVideo from "react-modal-video";
import ReactTooltip from "react-tooltip";

import Sunset from "../components/Sunset";

import "../styles/modal-video.min.css";
import "../styles/Video.css";

const API = "AIzaSyB-bx76Yd6FRL6ZX-YyKbNWGm7xxPdUUN0";
const CHANNEL_ID = "UC6Hm_7G7JHTFoeLpvfCs7sQ";
const RESULT = 12;
const FINAL_URL = `https://www.googleapis.com/youtube/v3/search?key=${API}&channelId=${CHANNEL_ID}&part=snippet,id&order=date&maxResults=${RESULT}`;

class Video extends Component {
    state = {
        data: [],
        isOpen: false,
        videoId: "",
        loading: true,
    };

    componentDidMount() {
        const cachedData = localStorage.getItem("videoData");
        const cachedTime = localStorage.getItem("videoDataTime");
        const currentTime = Date.now();

        // Cache data if none exists or if data is more than 1 hour old
        if (!cachedData || !cachedTime || currentTime - cachedTime > 3600000) {
            fetch(FINAL_URL)
                .then(response => response.json())
                .then(responseJson => {
                    const data = responseJson.items.map(item => ({
                        thumbnail: item.snippet.thumbnails.medium,
                        videoId: item.id.videoId,
                        title: item.snippet.title,
                    }));

                    this.setState({ data, loading: false });
                    localStorage.setItem("videoData", JSON.stringify(data));
                    localStorage.setItem(
                        "videoDataTime",
                        currentTime.toString()
                    );
                })
                .catch(error => {
                    console.error(error);
                });
        } else {
            this.setState({ data: JSON.parse(cachedData), loading: false });
        }

        this.updatePredicate();
        window.addEventListener("resize", this.updatePredicate);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updatePredicate);
    }

    updatePredicate = () => {
        this.setState({ isDesktop: window.innerWidth > 600 });
    };

    openModal = videoId => {
        this.setState({ isOpen: true, videoId });
    };

    htmlDecode = input => {
        const e = document.createElement("textarea");
        e.innerHTML = input;
        return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    };

    render() {
        const { isOpen, data, videoId, loading } = this.state;

        if (loading) {
            return <div>Loading...</div>;
        }

        return (
            <div>
                <Sunset />
                <ModalVideo
                    channel="youtube"
                    isOpen={isOpen}
                    videoId={videoId}
                    onClose={() => this.setState({ isOpen: false })}
                    className="modal-video"
                />
                <div>
                    <div className="mt-5 mb-2 pb-5 d-flex row justify-content-center youtube">
                        {data.map(({ thumbnail, videoId, title }) => (
                            <div
                                key={thumbnail.url}
                                className="p-4 thumbnail"
                                onClick={() => this.openModal(videoId)}
                                data-tip={this.htmlDecode(title)}
                            >
                                <ReactTooltip
                                    border
                                    backgroundColor={"black"}
                                    effect="solid"
                                />
                                <img
                                    src={thumbnail.url}
                                    alt="YouTube Thumbnail"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video.js